<script>
  import { userbaseStore } from "./stores/stores";
  import Header from "./components/Header.svelte";
  import Footer from "./components/Footer.svelte";
  import MainTabs from "./components/MainTabs.svelte";

  // db login
  let userObject = null;
  const userbase = window.userbase;
  // stores
  $userbaseStore = userbase;

  let authPromise = userbase
    .init({ appId: "063b40d8-4864-4095-9d05-33d24e01c395" })
    .then(({ user }) => (userObject = user));

  // auth
  let username, password;
  const signIn = () =>
    (authPromise = $userbaseStore
      .signIn({ username, password })
      .then((user) => (userObject = user)));
  const signUp = () =>
    (authPromise = $userbaseStore
      .signUp({ username, password })
      .then((user) => (userObject = user)));
  const signOut = () =>
    (authPromise = $userbaseStore.signOut().then(() => (userObject = null)));
</script>

<Header />
<main>
  {#if !userObject}
    <div class="login">
      {#await authPromise}Loading...{:then _}
        {#if !userObject}
          <form on:submit|preventDefault>
            <label for="username">Username</label>
            <input type="text" id="username" bind:value={username} />
            <label for="password">Password</label>
            <input type="text" id="password" bind:value={password} /> <br />
            <button on:click={signIn} type="button">Sign in</button>
            <button on:click={signUp} type="button">Sign up</button>
          </form>
        {:else}
          <h1>H1, {userObject.username}</h1>
          <button class="logout" on:click={signOut} type="button"
            >Log Out</button
          >
        {/if}
      {:catch error}Error! {error}
      {/await}
    </div>
  {:else}
    <MainTabs />
    <div class="userblock">
      Hello, {userObject.username}!
      <button class="logout" on:click={signOut} type="button">Log Out</button>
    </div>
  {/if}
</main>
<Footer />

<style>
  main {
    max-width: 1440px;
    margin: 40px auto;
  }
  .login {
    text-align: center;
  }
  .userblock {
    position: absolute;
    top: 10px;
    right: 10px;
  }
</style>
